import React from "react";
import {Typography} from "@mui/material";
import {White} from "../../theme/styles";

type Props = {
    /** Section name shown in the blue bar, e.g. "Documents". */
    title: string;
    /** Optional right-aligned content (persona readout, buttons, menus). */
    children?: React.ReactNode;
};

/**
 * The standard 52px blue title bar. It carries the SECTION name and nothing else; the page's own
 * icon-and-title header sits below it in the content column, ruled off from what follows, matching
 * the Data Catalog. Keeping the bar to one line is what lets it stay a fixed height everywhere.
 */
export default function PageHeader({title, children}: Props) {
    return (
        <div style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            height: 52,
            minHeight: 52,
            backgroundColor: "#1498D8",
            flexShrink: 0,
        }}>
            <div style={{paddingLeft: "20px", minWidth: 0, overflow: "hidden"}}>
                <Typography style={{fontSize: 24, fontWeight: 400, color: White}}>{title}</Typography>
            </div>
            {children ? (
                <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginRight: "20px", flexShrink: 0}}>
                    {children}
                </div>
            ) : null}
        </div>
    );
}
